(function ($) {
  'use strict';

  $(document).ready(function () {
    $('#partner-stores-search').on('search keypress', function (e) {
      if (e.which === 13) {
        // 13 is the Enter key code
        document.getElementById('loading').style.display = 'flex';

        const searchText = $(this).val(); // Get input value

        $.ajax({
          url: ajax_callback_data.ajax_url,
          type: 'POST',
          data: {
            action: 'partner_stores_filter',
            nonce: ajax_callback_data.ajax_nonce,
            searchText,
          },
          success: function (response) {
            $('#partner-stores-listing').html(response.html);

            document.getElementById('loading').style.display = 'none';
          },
          error: function (xhr, status, error) {
            console.error(error);
            document.getElementById('loading').style.display = 'none';
          },
        });
      }
    });
  });
})(jQuery);
